import { BehaviorSubject } from "rxjs";
import { fetchWrapper } from "../utils/fetch-wrapper";

const userId = new BehaviorSubject(localStorage.getItem("user"));
const tokenSubject = new BehaviorSubject(localStorage.getItem("token"));

const usersService = {
  user: userId.asObservable(),
  token: tokenSubject.asObservable(),
  get userValue() {
    return userId.value;
  },
  get tokenValue() {
    return tokenSubject.value;
  },
  new_password,
  reset_password,
  forget_password,
  putenv,
  login_emulator,
  putinfo2,
  putpassword,
  putinfo,
  login,
  logingoogle,
  logout,
  post,
  put,
  register,
  getAll,
  getAllSauf,
  getById,
  getAll_notinactif,
  AssigneUsersActif,
  getMe,
  get_members_actif,
  firsttime,
  getAllOrganisationSauf,
  getAllUsersOFOrganisationSaufMeAndActif,
  delete: _delete,
  tuto_frist,
  refresh,
  
};

function new_password(id: string, data: any) {
  return fetchWrapper.put(`auth/reset-new-password/${id}`, data);
}

function reset_password(data: any) {
  return fetchWrapper.post(`auth/reset-password-token`, data);
}

function forget_password(data: any) {
  return fetchWrapper.post(`auth/forget-password`, data);
}

function post(data) {
  return fetchWrapper.post(`users/`, data);
}

function put(id: number, data: any) {
  return fetchWrapper.put(`users/${id}`, data);
}

function putenv(id: number, data: any) {
  return fetchWrapper.put(`users/env/${id}`, data);
}

function putpassword(id: number, data: any) {
  return fetchWrapper.put(`users/${id}/password`, data);
}

function putinfo(id: number, data: any) {
   return fetchWrapper.put_formdata(`users/${id}`, data);
}

function putinfo2(id: number, data: any) {
  return fetchWrapper.put_formdata(`users/id/${id}`, data);
}

async function login(data) {
  return fetchWrapper
    .post_token(`auth/login`, data)
    .then((response) => response.json())
    .then((data) => {
      tokenSubject.next(data.access_token);
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);

      return data.access_token;
    });
}

async function login_emulator(data) {
  return fetchWrapper
    .post_token(`auth/login/emu`, data)
    .then((response) => response.json())
    .then((data) => {
      tokenSubject.next(data.access_token);
      localStorage.setItem("token", data.access_token);
      return data.access_token;
    });
}

async function logingoogle() {
  return fetchWrapper.get("auth/login/google");
}

function logout() {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
}

function firsttime(user_id) {
  return fetchWrapper.get(`users/firsttime/${user_id}`);
}
function register(user) {
  return fetchWrapper.post(`auth/signup`, user);
}

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");
  return fetchWrapper.get(`users/?${queryString}`);
}

function getAllOrganisationSauf(user_id, client_id) {
  return fetchWrapper.get(`users/organisation/${client_id}/sauf/${user_id}`);
}

function getAllUsersOFOrganisationSaufMeAndActif(user_id, client_id, actif_id) {
  return fetchWrapper.get(
    `users/organisation/${client_id}/sauf/${user_id}/actif/${actif_id}`
  );
}
function getAllSauf(user_id) {
  return fetchWrapper.get(`users/sauf/${user_id}`);
}

function getAll_notinactif(id) {
  return fetchWrapper.get(`users/not_in_actif/${id}`);
}

function AssigneUsersActif(body) {
  return fetchWrapper.post("users/members/actif", body);
}

function getById(id) {
  return fetchWrapper.get(`users/${id}`);
}

function getMe() {
  return fetchWrapper.get(`auth/me`).then((data) => {
    userId.next(data);
    localStorage.setItem("user", JSON.stringify(data));
    return data;
  });
}

function _delete(id) {
  return fetchWrapper.delete(`users/${id}`);
}

function get_members_actif(actif_id) {
  return fetchWrapper.get(`users/members/actif/${actif_id}`);
}

function tuto_frist(data) {
  return fetchWrapper.post("users/tuto", data);
}

async function refresh() {
  const refreshToken = localStorage.getItem("refresh_token");

  if (!refreshToken) {
    throw new Error("No refresh token");
  }

  const data = await fetchWrapper.post_refresh("auth/refresh", refreshToken);

  tokenSubject.next(data.access_token);

  localStorage.setItem("token", data.access_token);
  localStorage.setItem("refresh_token", data.refresh_token);

  // ✅ IMPORTANT
  return data;
}

// function isSuperAdmin() {
//   return userSubject.roles.includes('ROLE_ADMIN_GEX');
// }

// function isAdmin() {
//   return userSubject.value.roles.includes('ROLE_ADMIN');
// }

// function isVisiteur() {
//   return userSubject.value.roles.includes('ROLE_VIEWER');
// }
// function isEditeur() {
//   return userSubject.value.roles.includes('ROLE_EDITEUR');
// }

export default usersService;
